









































import { Vue, Component, Prop } from 'vue-property-decorator';
import { EButtonType } from '@getaccept/lib-ui';
import type {
  EContext,
  IPricingTableSection,
  IPricingTableCurrencySettings,
  IMergeValues,
  IField,
} from '@getaccept/editor-lib';
import {
  ENumberInputType,
  EValueAlign,
  getColumns,
  PricingTableHelper,
  getGridTemplateColumns,
  getRowsSortedByColumnOrder,
  getSectionHeader,
  getSectionSummary,
} from '@getaccept/editor-lib';
import type { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';
import type { IRecipient } from '@lib-shared/types/Recipient';
import PricingTableColumnHeaders from './PricingTableColumnHeaders.vue';
import PricingTableRow from './PricingTableRow.vue';
import PricingTableSectionSummary from './PricingTableSectionSummary.vue';

@Component({
  components: {
    PricingTableColumnHeaders,
    PricingTableRow,
    PricingTableSectionSummary,
  },
  data: () => ({
    EValueAlign,
    ENumberInputType,
    EButtonType,
    getColumns,
    getGridTemplateColumns,
    getRowsSortedByColumnOrder,
    getSectionSummary,
    getSectionHeader,
    PricingTableHelper,
  }),
})
export default class PricingTableSection extends Vue {
  @Prop() sections: IPricingTableSection[];
  @Prop() sectionId: string;
  @Prop() currencySettings: IPricingTableCurrencySettings;
  @Prop() isPreCalculated: boolean;
  @Prop() mergeValues: IMergeValues;
  @Prop() fields: IField[];
  @Prop() context: EContext;
  @Prop() isBlockWidthSmall: boolean;
  @Prop() recipientInput: IEditorRecipientInput[];
  @Prop() recipient: IRecipient;

  showAddMenu = false;
}
